import React from 'react';

const SubFieldClass = () => {
  return (
    <div>
      <h4>
        Subfield [class]
      </h4>
      <p>
        GS1 GPC class (division of a family): 6-digit code followed by 2 zeroes (00)
      </p>
      <p>
        <strong>OPTIONAL</strong><br/>
        <strong>REPEATABLE</strong>
      </p>
      <p className="pt-callout pt-intent-warning pt-icon-info-sign">
        <strong>Important:</strong> This subfield cannot co-exist with the subfield [brick].
      </p>
      <div>
        Example:
      </div>
      <pre>
          <code className="language-xml">
            {`<recall lang="en" xmlns="urn:recall-schema">
  <product_code>
    <publication>2011-12-01</publication>
    <class>58493800</class>
    <class>56793800</class>
  </product_code>
  ...
</recall>
`}
          </code>
        </pre>
    </div>
  );
};

export default SubFieldClass;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/sub-field-class.js